<template>
  <div
    class="color-circle"
    :style="{
      backgroundColor: colorHex,
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%',
    }"
  ></div>
</template>

<script>
export default {
  name: 'ColorCircle',
  props: {
    colorHex: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 30,
    },
  },
}
</script>

<style scoped></style>
